import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/content";

export default function TermsPage() {
  const sections = [
    {
      heading: "1. About these terms",
      paragraphs: [
        `These terms govern your use of the ${COMPANY.website} website operated by ${COMPANY.name}. By using this website you accept these terms.`,
      ],
    },
    {
      heading: "2. Use of this website",
      paragraphs: [
        "You may use this website for lawful purposes only. You must not misuse it, attempt to gain unauthorised access, or use it in any way that could damage or impair the site or its availability.",
      ],
    },
    {
      heading: "3. No donations through this website",
      paragraphs: [
        "This website is a corporate website for Amanah Promotions. It does not process donations or payments and does not collect financial or card details from members of the public.",
      ],
    },
    {
      heading: "4. Intellectual property",
      paragraphs: [
        "The content, branding, logos and design of this website are owned by or licensed to Amanah Promotions and are protected by applicable intellectual property laws. You may not reproduce them without permission.",
      ],
    },
    {
      heading: "5. Accuracy of information",
      paragraphs: [
        "We take care to ensure information on this website is accurate but provide it for general information only. It does not constitute a contract, offer or guarantee of any particular outcome.",
      ],
    },
    {
      heading: "6. Limitation of liability",
      paragraphs: [
        "To the extent permitted by law, Amanah Promotions is not liable for any loss arising from reliance on the content of this website. Nothing in these terms excludes liability that cannot lawfully be excluded.",
      ],
    },
    {
      heading: "7. Governing law",
      paragraphs: [
        "These terms are governed by the laws of England and Wales, and any disputes are subject to the exclusive jurisdiction of the courts of England and Wales.",
      ],
    },
    {
      heading: "8. Company details",
      paragraphs: [
        `${COMPANY.name} is registered in England and Wales. Company number ${COMPANY.number}. Registered office: ${COMPANY.office}. Contact: ${COMPANY.email}.`,
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Legal"
      title="Website Terms"
      intro="The terms on which you may use the Amanah Promotions website."
      updated="8 August 2026"
      sections={sections}
    />
  );
}
